import { API_CALL } from '../../../../middleware/api';

export const GET_REPORT_REQ = 'get-report';
export const GET_REPORT_REQ_RESULT = 'get-report/result';
export const GET_REPORT_REQ_ERROR = 'get-report/error';

export const GET_DEVICES_REPORT_REQ = 'get-devices-report';
export const GET_DEVICES_REPORT_REQ_RESULT = `${GET_DEVICES_REPORT_REQ}/result`;
export const GET_DEVICES_REPORT_REQ_ERROR = `${GET_DEVICES_REPORT_REQ}/error`;

export const GET_DEVICES_REPORT_INITIAL_REQ = 'get-devices-report-initial';
export const GET_DEVICES_REPORT_INITIAL_REQ_RESULT = `${GET_DEVICES_REPORT_INITIAL_REQ}/result`;
export const GET_DEVICES_REPORT_INITIAL_REQ_ERROR = `${GET_DEVICES_REPORT_INITIAL_REQ}/error`;

export const GET_DEVICES_REPORT_RECURRING_REQ = 'get-devices-report-recurring';
export const GET_DEVICES_REPORT_RECURRING_REQ_RESULT = `${GET_DEVICES_REPORT_RECURRING_REQ}/result`;
export const GET_DEVICES_REPORT_RECURRING_REQ_ERROR = `${GET_DEVICES_REPORT_RECURRING_REQ}/error`;

export const GET_PROGRAM_STATISTICS = 'get-program-statistics';
export const GET_PROGRAM_STATISTICS_RESULT = `${GET_PROGRAM_STATISTICS}/result`;
export const GET_PROGRAM_STATISTICS_ERROR = `${GET_PROGRAM_STATISTICS}/error`;

export const GET_PATIENTS_STATISTICS = 'get-patients-statistics';
export const GET_PATIENTS_STATISTICS_RESULT = `${GET_PATIENTS_STATISTICS}/result`;
export const GET_PATIENTS_STATISTICS_ERROR = `${GET_PATIENTS_STATISTICS}/error`;

export const GET_ESI_PATIENTS_STATS = 'get-esi-patients-stats';
export const GET_ESI_PATIENTS_STATS_RESULT = `${GET_ESI_PATIENTS_STATS}/result`;
export const GET_ESI_PATIENTS_STATS_ERROR = `${GET_ESI_PATIENTS_STATS}/error`;

export const GET_ENROLLMENTS_SUMMARY = 'get-enrollments-summary';
export const GET_ENROLLMENTS_SUMMARY_RESULT = `${GET_ENROLLMENTS_SUMMARY}/result`;
export const GET_ENROLLMENTS_SUMMARY_ERROR = `${GET_ENROLLMENTS_SUMMARY}/error`;

export const GET_SHIPMENT_SUMMARY = 'get-shipment-summary';
export const GET_SHIPMENT_SUMMARY_RESULT = `${GET_SHIPMENT_SUMMARY}/result`;
export const GET_SHIPMENT_SUMMARY_ERROR = `${GET_SHIPMENT_SUMMARY}/error`;

export const GET_ORGANIZATIONS_SUMMARY = 'get-organizations-summary';
export const GET_ORGANIZATIONS_SUMMARY_RESULT = `${GET_ORGANIZATIONS_SUMMARY}/result`;
export const GET_ORGANIZATIONS_SUMMARY_ERROR = `${GET_ORGANIZATIONS_SUMMARY}/error`;

export const GET_OPERATIONAL_DATASET = 'get-operational-dataset';
export const GET_OPERATIONAL_DATASET_RESULT = `${GET_OPERATIONAL_DATASET}/result`;
export const GET_OPERATIONAL_DATASET_ERROR = `${GET_OPERATIONAL_DATASET}/error`;

export const GET_DEVICE_UTILIZATION_SUMMARY = 'get-device-utilization-summary';
export const GET_DEVICE_UTILIZATION_SUMMARY_RESULT = `${GET_DEVICE_UTILIZATION_SUMMARY}/result`;
export const GET_DEVICE_UTILIZATION_SUMMARY_ERROR = `${GET_DEVICE_UTILIZATION_SUMMARY}/error`;

export const GET_PROGRAM_ANALYTICS = 'get-program-analytics';
export const GET_PROGRAM_ANALYTICS_RESULT = `${GET_PROGRAM_ANALYTICS}/result`;
export const GET_PROGRAM_ANALYTICS_ERROR = `${GET_PROGRAM_ANALYTICS}/error`;

export const actions = {
  getReport: endDate => ({
    [API_CALL]: {
      endpoint: 'portal/report/overview',
      method: 'get',
      params: {
        endDate,
      },
    },
    type: GET_REPORT_REQ,
  }),
  getDevicesReportSummary: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/summary',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
        filterBy: 'billing_status:sample,billable',
      },
      responseType: 'blob',

    },
    type: GET_DEVICES_REPORT_REQ,
  }),
  getDevicesReportInitial: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/initial',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
        filterBy: 'billing_status:sample,billable',
      },
    },
    type: GET_DEVICES_REPORT_INITIAL_REQ,
  }),
  getDevicesReportRecurring: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/recurring',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
      },
    },
    type: GET_DEVICES_REPORT_RECURRING_REQ,
  }),

  getProgramStatistics: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/program_statistics',
      method: 'get',
      params: request,
    },
    type: GET_PROGRAM_STATISTICS,
  }),
  getPatientsStatistics: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/patients_statistics',
      method: 'get',
      params: request,
    },
    type: GET_PATIENTS_STATISTICS,
  }),
  getEnrollmentsSummary: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/enrollments_summary',
      method: 'get',
      params: request,
    },
    type: GET_ENROLLMENTS_SUMMARY,
  }),
  getShipmentSummary: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/shipment_summary',
      method: 'get',
      params: request,
    },
    type: GET_SHIPMENT_SUMMARY,
  }),
  getOrganizationsSummary: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/organizations_summary',
      method: 'get',
      params: request,
    },
    type: GET_ORGANIZATIONS_SUMMARY,
  }),
  getOperationalDataset: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/operational_dataset',
      method: 'get',
      params: request,
    },
    type: GET_OPERATIONAL_DATASET,
  }),
  getDeviceUtilizationSummary: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/device_utilization_summary',
      method: 'get',
      params: request,
    },
    type: GET_DEVICE_UTILIZATION_SUMMARY,
  }),
  getEsiPatientStats: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/report/esi_patients',
      params: request,
    },
    type: GET_ESI_PATIENTS_STATS,
  }),
  getProgramAnalytics: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: '/portal/report/program_analytics/download',
      params: request,
    },
    type: GET_PROGRAM_ANALYTICS,
  }),
};
